import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import { useForm } from "vee-validate";
import { useErrors } from "@/utils/api-functions";
//@ts-ignore
import FormInput from "@/components/form/input.vue";
//@ts-ignore
import Submit from "@/components/form/submit.vue";
import * as Yup from "yup";
import { nl } from "yup-locales";
import { useApiStore } from "@/stores/api";
import { useReCaptcha } from "vue-recaptcha-v3";


export default /*#__PURE__*/_defineComponent({
  props: {
    groups: { type: null, required: true },
    tags: { type: null, required: true },
    mailchimpGroupId: { type: String, required: true }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as { groups: any; tags: any; mailchimpGroupId: string }



const apiErrors = useErrors();
const apiStore = useApiStore();
const reCaptcha = useReCaptcha();

const success = ref(false);
const loading = ref(false);

Yup.setLocale(nl);

const { handleSubmit, isSubmitting } = useForm({
    initialValues: {
        email: "",
        href: window.location.href,
        pathname: window.location.pathname,
        mailchimp_ids: [],
        mailchimp_group_id: props.mailchimpGroupId,
        tags: props.tags,
    },
    validationSchema: Yup.object({
        email: Yup.string().email().required().label("Email"),
        href: Yup.string().required(),
        mailchimp_group_id: Yup.string().label("Mailchimp group ids"),
        mailchimp_ids: Yup.array().label("Mailchimp ids"),
        tags: Yup.string().label("Tags"),
        pathname: Yup.string().required(),
    }),
});

const onSubmit = handleSubmit(async (values, { resetForm }) => {
    try {
        loading.value = true;

        await reCaptcha!.recaptchaLoaded();

        const token = await reCaptcha!.executeRecaptcha("login");

        // @ts-ignore
        apiStore.subscribeNewsletter({ ...values, "g-recaptcha-response": token });

        // @ts-ignore
        if (window.hasOwnProperty("dataLayer") && dataLayer) {
            // @ts-ignore
            dataLayer.push({
                event: "cf7submission",
                formId: "1563",
                response: [
                    { name: "email", value: values.email },
                    { name: "href", value: window.location.href },
                    { name: "pathname", value: window.location.pathname },
                ],
            });
        }

        success.value = true;

        setTimeout(resetForm, 500);
    } catch (error) {
        apiErrors.parse(error);
    } finally {
        loading.value = false;
    }
});

const __returned__ = { props, apiErrors, apiStore, reCaptcha, success, loading, handleSubmit, isSubmitting, onSubmit, FormInput, Submit }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})